import axios from './../http'

function query(data) {
    return axios.post('/sys/i18n/query', data);
}

function get(id) {
    return axios.get('/sys/i18n/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/i18n/add', data);
}

function update(data) {
    return axios.post('/sys/i18n/update', data);
}

function del(data) {
    return axios.post('/sys/i18n/del', data);
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/sys/i18n/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}

function exportExcel(data){
    const url =  "/sys/i18n/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Traslation"+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}


function exportHorExcel(data){
    const url =  "/sys/i18n/exportHorExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Traslation"+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}
export default {
    query,
    get,
    add,
    update,
    del,
    importExcel,
    exportExcel,
    exportHorExcel
}